import {defineStore} from "pinia";
import NProgress from "nprogress"

NProgress.configure({
  showSpinner: false
})

export const useLayoutStore = defineStore("layout", {
  state: () => ({
    isOpenMobileMenu: false,
    progress: NProgress,
    loadingList: []
  }),

  getters: {
    hasLoading() {
      return Boolean(this.loadingList.length)
    },
    needHideLayout() {
      return this.loadingList.some(({hideLayout}) => hideLayout)
    }
  },

  actions: {
    toggleMobileMenu() {
      this.isOpenMobileMenu = !this.isOpenMobileMenu
    },
    closeMobileMenu() {
      if(!this.isOpenMobileMenu) return
      this.isOpenMobileMenu = false
    },
    openMobileMenu() {
      if(this.isOpenMobileMenu) return
      this.isOpenMobileMenu = true
    },
    showLoading(loadingKey, hideLayout = false) {
      if(this.loadingList.some(({key}) => key === loadingKey)) return
      this.loadingList.push({key: loadingKey, hideLayout})
    },
    hideLoading(loadingKey) {
      const loadingIndex = this.loadingList.findIndex(({key}) => key === loadingKey)
      if(loadingIndex === -1) return
      this.loadingList.splice(loadingIndex, 1)
    },
    startProgress() {
      this.progress.start()
    },
    doneProgress() {
      this.progress.done()
    }
  }
})